module.exports = __webpack_public_path__ + "static/media/ipma.207fdb06.svg";